import React from 'react';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-gold-500 text-navy-900 py-4 border-y border-gold-600" data-id="element-324">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4 text-sm md:text-base font-bold" data-id="element-326">
          <div className="flex items-center gap-2" data-id="element-327">
            <Users className="w-5 h-5" data-id="element-328" />
            <span data-id="element-329">+300 profes confían</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-navy-900/30 rounded-full" data-id="element-330" />
          <div className="flex items-center gap-2" data-id="element-331">
            <BookOpen className="w-5 h-5" data-id="element-332" />
            <span data-id="element-333">6+6 Tomos + Bonos</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-navy-900/30 rounded-full" data-id="element-334" />
          <div className="flex items-center gap-2" data-id="element-335">
            <Star className="w-5 h-5 fill-navy-900" data-id="element-336" />
            <span data-id="element-337">4.9/5 valoración</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-navy-900/30 rounded-full" data-id="element-338" />
          <div className="flex items-center gap-2" data-id="element-339">
            <MapPin className="w-5 h-5" data-id="element-340" />
            <span data-id="element-341">🇦🇷 Todo el país</span>
          </div>
        </div>
      </div>
    </div>;
}